import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const dest = (location.state && location.state.from) || "/quicklinks";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (isAuthenticated) navigate(dest, { replace: true }); }, [isAuthenticated, dest, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email.trim(), password);
      navigate(dest, { replace: true });
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0a0806", padding: "24px", fontFamily: "Inter, system-ui, sans-serif" }}>
      <form onSubmit={submit} data-testid="login-form" style={{ width: "100%", maxWidth: "380px", background: "#14100b", border: "1px solid rgba(184,115,51,.28)", borderRadius: "16px", padding: "34px 30px" }}>
        <div style={{ textAlign: "center", marginBottom: "22px" }}>
          <div style={{ fontSize: "11px", letterSpacing: "3px", color: "#D4AF37", textTransform: "uppercase" }}>INSPIYAH Ecosystem</div>
          <h1 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 300, fontSize: "30px", color: "#efe6d8", margin: "8px 0 4px" }}>Keeper Access</h1>
          <p style={{ fontSize: "12px", color: "#9d9284", margin: 0 }}>Sign in to reach internal tools</p>
        </div>

        <label style={{ fontSize: "11px", color: "#9d9284", letterSpacing: "1px" }}>EMAIL</label>
        <input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username"
          style={{ width: "100%", margin: "6px 0 16px", padding: "11px 13px", background: "rgba(255,255,255,.04)", border: "1px solid rgba(184,115,51,.35)", borderRadius: "9px", color: "#efe6d8", fontSize: "14px", outline: "none" }} />

        <label style={{ fontSize: "11px", color: "#9d9284", letterSpacing: "1px" }}>PASSWORD</label>
        <input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password"
          style={{ width: "100%", margin: "6px 0 8px", padding: "11px 13px", background: "rgba(255,255,255,.04)", border: "1px solid rgba(184,115,51,.35)", borderRadius: "9px", color: "#efe6d8", fontSize: "14px", outline: "none" }} />

        {error && <div data-testid="login-error" style={{ color: "#f7a1a1", fontSize: "12px", margin: "6px 0 4px" }}>{error}</div>}

        <button data-testid="login-submit" type="submit" disabled={busy}
          style={{ width: "100%", marginTop: "16px", padding: "12px", border: "none", borderRadius: "999px", cursor: busy ? "wait" : "pointer", fontWeight: 700, letterSpacing: "1px", fontSize: "13px", color: "#0a0806", background: "linear-gradient(90deg,#B87333,#D4AF37,#C45B2D)", opacity: busy ? 0.7 : 1 }}>
          {busy ? "SIGNING IN…" : "SIGN IN"}
        </button>
      </form>
    </div>
  );
}
